// import random from "../helpers/randomNum";
import randomAngle from "../helpers/randomAngle";
import randomSpin from "../helpers/randomSpin";
import maxSpin from "./maxSpin";

export default function nextRow(
  movePath,
  _column,
  handleFinalTouchAngle,
  startingAngle,
  rows
) {
  let touch, next;
  next = movePath.shift(); // 1 - right, 0 - left
  let afterNext = movePath[0];

  const column = _column + +next;

  let finalAngle = randomAngle(next, afterNext, "nextRow", startingAngle);
  let spin = randomSpin(finalAngle, next, startingAngle); // min - 0 | max - 6
  // let spin = 4; // min - 0 | max - 6

  // 12 rows
  const checkedSpin = maxSpin(rows, spin);

  // let spin = 1; // min - 0 | max - 6

  let time = 200 + checkedSpin * 50;

  touch = handleFinalTouchAngle(finalAngle);
  return [touch, checkedSpin, time, column, finalAngle];
}
